import { render, staticRenderFns } from "./ProvincesMap.vue?vue&type=template&id=025cb8a1&scoped=true&"
import script from "./ProvincesMap.vue?vue&type=script&lang=js&"
export * from "./ProvincesMap.vue?vue&type=script&lang=js&"
import style0 from "./ProvincesMap.vue?vue&type=style&index=0&id=025cb8a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025cb8a1",
  null
  
)

export default component.exports